import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '@/api';
import { analyticsKeys } from '@/lib/queryKeys';
import { GC_TIMES, STALE_TIMES } from '@/lib/constants';

export function useAnalyticsInsights(periodDays: number, enabled = true) {
  return useQuery({
    queryKey: analyticsKeys.insights(periodDays),
    queryFn: () => analyticsApi.insights(periodDays),
    enabled,
    staleTime: STALE_TIMES.long,
    gcTime: GC_TIMES.long,
  });
}
